// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Ichp","options":"AnswerScale_options__2GFSP","selected":"AnswerScale_selected__HLGjf"};